import { Member, AvailableMember } from '../types/member';

type MemberLike = Pick<Member | AvailableMember, 'LastName' | 'FirstName'>;
type LastNameOnly = Pick<Member | AvailableMember, 'LastName'>;

/**
 * 自社メンバー一覧の中で苗字が重複している場合は「苗字(名の頭文字)」を返す。
 * 重複していなければ苗字のみを返す。
 *
 * Why: 同姓のメンバーが追加された場合に、苗字のみの表示では識別できないため。
 */
export const buildMemberShortName = (
  member: MemberLike,
  allMembers: LastNameOnly[]
): string => {
  const sameLastNameCount = allMembers.filter(
    (m) => m.LastName === member.LastName
  ).length;
  if (sameLastNameCount > 1 && member.FirstName) {
    return `${member.LastName}(${member.FirstName.charAt(0)})`;
  }
  return member.LastName;
};

/**
 * 保存された名前文字列（短縮形 or 旧 LastName 単独）から自社メンバーを逆引きする。
 * 短縮形での一致を優先し、見つからなければ LastName 単独でフォールバック。
 *
 * Why: 同姓追加前のデータは LastName のみで保存されているため、過去データ互換が必要。
 */
export const findMemberBySavedName = <T extends Member>(
  savedName: string,
  allMembers: T[]
): T | undefined => {
  return (
    allMembers.find((m) => buildMemberShortName(m, allMembers) === savedName) ??
    allMembers.find((m) => m.LastName === savedName)
  );
};
